/**
 * DebugGetCaptchaRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DebugGetCaptchaRes
 */
export interface DebugGetCaptchaRes {
  /** 验证码 */
  code?: string
  /** 过期时间 */
  expire_at?: string
  /** 创建时间 */
  created_at?: string
}

/**
 * DebugGetCaptchaRes Schema
 */
export const DebugGetCaptchaResSchema: SchemaDefinition = {
  properties: {
    code: {
      description: '验证码',
      format: 'string',
      type: 'string',
      label: '验证码',
    },
    expire_at: {
      description: '过期时间',
      format: '*time.Time',
      type: 'string',
      label: '过期时间',
    },
    created_at: {
      description: '创建时间',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
  },
  type: 'object',
}
